//SuperAdmin-Users 확인

import { API_V2 } from './apiVersion';

export const SUPERADMIN_USER_ENDPOINTS = {
  ACCOUNTS : {
    CREATE: `${API_V2}/superadmin/admins`,

    LIST: `${API_V2}/superadmin/admins`,

    ACTIVATE: (adminId: number) =>
      `${API_V2}/superadmin/admins/${adminId}/activate`,

    DEACTIVATE: (adminId: number) =>
      `${API_V2}/superadmin/admins/${adminId}/deactivate`,
  },

  RESET_PASSWORD: (userId: string) =>
    `${API_V2}/superadmin/users/${encodeURIComponent(userId)}/password/reset`,
} as const;
